import React, { Component } from 'react';
import { getUserReceipts } from '../../utils/apputils';
import { connect } from 'react-redux';
import { receipts } from '../../store/actions';
import { Link } from 'react-router-dom';
import { Well } from 'react-bootstrap';
import { withRouter } from 'react-router-dom';

class ReceiptsClass extends Component {
  componentDidMount() {
    const { dispatch } = this.props;
    getUserReceipts(receipts, dispatch);
  }

  storeReceipt = receipt => {
    localStorage.setItem('receipts', JSON.stringify(receipt));
  };

  render() {
    const { receipts, user } = this.props;
    const data = receipts;
    if (user !== null) {
      return (
        <div className="container-fluid columns account account-content">
          <div className="col col-side">
            <nav className="side-nav">
              <ul>
                <li className="side-nav-item active js-orders">
                  <Link to="/orders">Your orders</Link>
                </li>
                <li className="side-nav-item js-account">
                  <Link to="/profile">Your account</Link>
                </li>
                <li className="side-nav-item js-pics">
                  <Link to="/library">Your pics</Link>
                </li>
              </ul>
            </nav>
          </div>
          <div className="account-content container" id="account-orders">
            <h1>Your orders</h1>
            <table className="table order-table">
              <thead>
                <tr>
                  <th className="col-date">Date</th>
                  <th className="col-invoice">Invoice</th>
                  <th className="col-desc">Description</th>
                  <th className="col-total">Total</th>
                  <th className="col-exvat">
                    <span className="sr-only">Total excluding VAT</span>
                  </th>
                </tr>
              </thead>
              <tbody>
                {data.map((receipt, i) => {
                  const {
                    date,
                    itemPurchased,
                    paymentId,
                    subtotal,
                    tax
                  } = receipt;
                  const options = {
                    year: 'numeric',
                    month: 'long',
                    day: 'numeric'
                  };
                  const dateFormatted = new Date(date).toLocaleString(
                    'en-GB',
                    options
                  );

                  return (
                    <tr key={`receipts${i}`}>
                      <td className="col-date">{dateFormatted}</td>
                      <td className="col-invoice">
                        <Link
                          to={`receipts/${paymentId}`}
                          target="_blank"
                          onMouseDown={() => this.storeReceipt(receipt)}
                        >
                          {paymentId}
                        </Link>
                      </td>
                      <td className="col-desc">{itemPurchased}</td>
                      <td className="col-total">{`£${(+subtotal + +tax).toFixed(
                        2
                      )}`}</td>
                      <td className="col-exvat">{`£${(+subtotal).toFixed(
                        2
                      )} ex VAT`}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      );
    } else {
      return (
        <div className="container">
          <h1>You need to login</h1>
          <Well className="account-well" bsSize="large">
            <p>Hit the 'Log in' button in the bar up there</p>
          </Well>
        </div>
      );
    }
  }
}

const mapStateToProps = state => ({
  receipts: state.receipts.receipts,
  user: state.users.user
});
const Receipts = withRouter(connect(mapStateToProps)(ReceiptsClass));

export default Receipts;



// WEBPACK FOOTER //
// ./src/comps/Receipts/Receipts.js